module.exports = __webpack_public_path__ + "customer-feedback-hero-c10ceab80090351f05f11d88ebac529a.webp";